/* */ 
(function(Buffer) {
  'use strict';
  var Promise = require('./util/promise'),
      Options = require('./options'),
      $Refs = require('./refs'),
      parse = require('./parse'),
      resolveExternal = require('./resolve-external'),
      bundle = require('./bundle'),
      dereference = require('./dereference'),
      url = require('./util/url'),
      maybe = require('call-me-maybe'),
      ono = require('ono');
  module.exports = $RefParser;
  module.exports.YAML = require('./util/yaml');
  function $RefParser() {
    this.schema = null;
    this.$refs = new $Refs();
  }
  $RefParser.parse = function(schema, options, callback) {
    var Class = this;
    var instance = new Class();
    return instance.parse.apply(instance, arguments);
  };
  $RefParser.prototype.parse = function(schema, options, callback) {
    var args = normalizeArgs(arguments);
    var promise;
    if (!args.path && !args.schema) {
      var err = ono('Expected a file path, URL, or object. Got %s', args.path || args.schema);
      return maybe(args.callback, Promise.reject(err));
    }
    this.schema = null;
    this.$refs = new $Refs();
    if (url.isFileSystemPath(args.path)) {
      args.path = url.fromFileSystemPath(args.path);
    }
    args.path = url.resolve(url.cwd(), args.path);
    if (args.schema && typeof args.schema === 'object') {
      this.$refs._add(args.path, args.schema);
      promise = Promise.resolve(args.schema);
    } else {
      promise = parse(args.path, this.$refs, args.options);
    }
    var me = this;
    return promise.then(function(result) {
      if (!result || typeof result !== 'object' || Buffer.isBuffer(result)) {
        throw ono.syntax('"%s" is not a valid JSON Schema', me.$refs._root$Ref.path || result);
      } else {
        me.schema = result;
        return maybe(args.callback, Promise.resolve(me.schema));
      }
    }).catch(function(e) {
      return maybe(args.callback, Promise.reject(e));
    });
  };
  $RefParser.resolve = function(schema, options, callback) {
    var Class = this;
    var instance = new Class();
    return instance.resolve.apply(instance, arguments);
  };
  $RefParser.prototype.resolve = function(schema, options, callback) {
    var me = this;
    var args = normalizeArgs(arguments);
    return this.parse(args.path, args.schema, args.options).then(function() {
      return resolveExternal(me, args.options);
    }).then(function() {
      return maybe(args.callback, Promise.resolve(me.$refs));
    }).catch(function(err) {
      return maybe(args.callback, Promise.reject(err));
    });
  };
  $RefParser.bundle = function(schema, options, callback) {
    var Class = this;
    var instance = new Class();
    return instance.bundle.apply(instance, arguments);
  };
  $RefParser.prototype.bundle = function(schema, options, callback) {
    var me = this;
    var args = normalizeArgs(arguments);
    return this.resolve(args.path, args.schema, args.options).then(function() {
      bundle(me, args.options);
      return maybe(args.callback, Promise.resolve(me.schema));
    }).catch(function(err) {
      return maybe(args.callback, Promise.reject(err));
    });
  };
  $RefParser.dereference = function(schema, options, callback) {
    var Class = this;
    var instance = new Class();
    return instance.dereference.apply(instance, arguments);
  };
  $RefParser.prototype.dereference = function(schema, options, callback) {
    var me = this;
    var args = normalizeArgs(arguments);
    return this.resolve(args.path, args.schema, args.options).then(function() {
      dereference(me, args.options);
      return maybe(args.callback, Promise.resolve(me.schema));
    }).catch(function(err) {
      return maybe(args.callback, Promise.reject(err));
    });
  };
  function normalizeArgs(args) {
    var path,
        schema,
        options,
        callback;
    args = Array.prototype.slice.call(args);
    if (typeof args[args.length - 1] === 'function') {
      callback = args.pop();
    }
    if (typeof args[0] === 'string') {
      path = args[0];
      if (typeof args[2] === 'object') {
        schema = args[1];
        options = args[2];
      } else {
        schema = undefined;
        options = args[1];
      }
    } else {
      path = '';
      schema = args[0];
      options = args[1];
    }
    if (!(options instanceof Options)) {
      options = new Options(options);
    }
    return {
      path: path,
      schema: schema,
      options: options,
      callback: callback
    };
  }
})(require('buffer').Buffer);
